import { useCallback, useEffect, useMemo } from "react";
import { useController as useDataTable } from "@/composites/data-table/hooks/use-controller";
import { useNotifications } from "@/app/hook/use-notifications";
import { DataTableControllerStoreType } from "@/composites/data-table/index";
import { TrackingListItemType } from "@/schemas/index";
import { useTrackingService } from "@/services";

export const useTable = () => {
  const { fetchTrackingListItems } = useTrackingService();
  const notifications = useNotifications();

  const fetchLoadData = useCallback(
    async ({
      pagination,
      dataSourceTotal,
    }: DataTableControllerStoreType<TrackingListItemType>): Promise<
      Partial<DataTableControllerStoreType<TrackingListItemType>>
    > => {
      try {
        const trackingItems = await fetchTrackingListItems();

        return {
          dataSource: trackingItems,
          dataSourceTotal: dataSourceTotal || trackingItems.length,
          pagination: {
            ...pagination,
            current: 1,
            pageSize: trackingItems.length || 10,
            total: trackingItems.length || 0,
          },
        };
      } catch (error) {
        notifications.show(error as Error);
        return {
          dataSource: [],
          initial: true,
          pagination: {
            ...pagination,
            total: 0,
          },
        };
      }
    },
    [fetchTrackingListItems],
  );

  const controllerDataTable = useDataTable<TrackingListItemType>(
    "products-delivery-table",
  );

  useEffect(() => {
    controllerDataTable.setLoadData(fetchLoadData);
  }, [fetchLoadData]);

  useEffect(() => {
    if (
      controllerDataTable?.initial === false &&
      controllerDataTable?.onLoadData
    ) {
      controllerDataTable.loadData();
    }
  }, [controllerDataTable?.onLoadData, controllerDataTable?.initial]);

  return useMemo(() => controllerDataTable, [controllerDataTable]);
};
